/* 
        define and export all the action types here and use them in actions as well as in reducers

        ==> export const ACTION_TYPE = "ACTION_TYPE"


*/

export const SET_INSTITUTE_DETAILS= "SET_INSTITUTE_DETAILS";
export const SET_AUTH_STATUS= "SET_AUTH_STATUS";
export const SET_INSTITUTE_ACCESS_TOKEN = "SET_INSTITUTE_ACCESS_TOKEN"
 
 